export default __webpack_public_path__ + "static/media/font2.0f61f85c.svg";